import { pathOr } from 'ramda';
import * as React from 'react';

import { IJsonQueryRangeValue } from '../../../types/jsonQuery';
import { useContext } from '../../../utils/useContext';
import { SquareMeterArea } from '../../../components/advancedFilters/SquareMeterArea';
import { useOfferType } from '../../../utils/useOfferType';

export const SquareMeterAreaContainer: React.FC = () => {
  const { jsonQuery, onChange } = useContext();
  const offerType = useOfferType();
  const totalArea = pathOr<IJsonQueryRangeValue>(
    { gte: undefined, lte: undefined },
    ['total_area', 'value'],
    jsonQuery,
  );
  const roomArea = pathOr<IJsonQueryRangeValue>({ gte: undefined, lte: undefined }, ['room_area', 'value'], jsonQuery);
  const kitchenArea = pathOr<IJsonQueryRangeValue>({ gte: undefined, lte: undefined }, ['kitchen', 'value'], jsonQuery);
  const livingArea = pathOr<IJsonQueryRangeValue>(
    { gte: undefined, lte: undefined },
    ['living_area', 'value'],
    jsonQuery,
  );

  const handleTotalAreaMinChange = React.useCallback(
    (gte: number | null) => {
      onChange({ action: 'setTotalAreaMin', arguments: [gte] });
    },
    [onChange],
  );

  const handleTotalAreaMaxChange = React.useCallback(
    (lte: number | null) => {
      onChange({ action: 'setTotalAreaMax', arguments: [lte] });
    },
    [onChange],
  );

  const handleRoomAreaMinChange = React.useCallback(
    (gte: number | null) => {
      onChange({ action: 'setRoomAreaMin', arguments: [gte] });
    },
    [onChange],
  );

  const handleRoomAreaMaxChange = React.useCallback(
    (lte: number | null) => {
      onChange({ action: 'setRoomAreaMax', arguments: [lte] });
    },
    [onChange],
  );

  const handleKitchenAreaMinChange = React.useCallback(
    (gte: number | null) => {
      onChange({ action: 'setKitchenAreaMin', arguments: [gte] });
    },
    [onChange],
  );

  const handleKitchenAreaMaxChange = React.useCallback(
    (lte: number | null) => {
      onChange({ action: 'setKitchenAreaMax', arguments: [lte] });
    },
    [onChange],
  );

  const handleLivingAreaMinChange = React.useCallback(
    (gte: number | null) => {
      onChange({ action: 'setLivingAreaMin', arguments: [gte] });
    },
    [onChange],
  );

  const handleLivingAreaMaxChange = React.useCallback(
    (lte: number | null) => {
      onChange({ action: 'setLivingAreaMax', arguments: [lte] });
    },
    [onChange],
  );

  return (
    <SquareMeterArea
      offerType={offerType}
      totalArea={totalArea}
      roomArea={roomArea}
      kitchenArea={kitchenArea}
      livingArea={livingArea}
      onTotalAreaMinChange={handleTotalAreaMinChange}
      onTotalAreaMaxChange={handleTotalAreaMaxChange}
      onRoomAreaMinChange={handleRoomAreaMinChange}
      onRoomAreaMaxChange={handleRoomAreaMaxChange}
      onKitchenAreaMinChange={handleKitchenAreaMinChange}
      onKitchenAreaMaxChange={handleKitchenAreaMaxChange}
      onLivingAreaMinChange={handleLivingAreaMinChange}
      onLivingAreaMaxChange={handleLivingAreaMaxChange}
    />
  );
};
